import {
  FileAttachmentButton,
  WebsiteAttachmentButton,
  YoutubeAttachmentButton,
} from './AttachmentButton';
import { FileOverIndicator } from './FileOverIndicator';
import { Label } from './Label';
import { MaterialAddButtons } from './MaterialAddButton';
import { TextArea } from './TextArea';

export const PromptTextArea = {
  TextArea,
  MaterialAddButtons,
  FileAttachmentButton,
  YoutubeAttachmentButton,
  WebsiteAttachmentButton,
  FileOverIndicator,
  Label,
};
